import { UserLevel } from '../enums/UserLevel';
import { UserOrigin } from '../enums/UserOrigin';
import { UserRole } from '../enums/UserRole';

export class User {
  constructor(
    private readonly id: number,
    private readonly username: string,
    private readonly preferredName: string | null,
    private readonly level: UserLevel,
    private readonly roles: UserRole[],
    private readonly origin: UserOrigin
  ) {}

  getId() {
    return this.id;
  }

  getUsername() {
    return this.username;
  }

  getPreferredName() {
    return this.preferredName;
  }

  getDisplayName() {
    return this.getPreferredName() || this.getUsername();
  }

  getLevel() {
    return this.level;
  }

  getRoles() {
    return this.roles;
  }

  getOrigin() {
    return this.origin;
  }
}
